<mat-card class="table-card mb-2">
  <mat-toolbar class="table-tools" role="heading" >
    <div fxFlex fxLayout fxLayoutAlign="start">
      <span class="fs1">{{title}}
        <span class="fw3" *ngIf="dataSource && dataSource.data && dataSource.data.length && title">
      ({{dataSource.data.length}}) </span></span>
    </div>
    <div fxFlex fxLayout fxLayoutAlign="end">
      <div fxLayout fxLayoutGap="15px" class="navigation-items">
        <form fxLayout="row" fxLayoutAlign="center center">
          <mat-form-field class="filter-tool mr-3" *ngIf="isFilterTable && filterSource && filterSource.length">
            <mat-label>{{title}}</mat-label>
            <mat-select [multiple]="false" (selectionChange)="updateTable($event)"
              placeholder="" name="filterkey" [(ngModel)]="filterKey">
              <mat-option *ngFor="let item of filterSource" [value]="item.value"> {{item.name}} </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- <mat-form-field class="filter-tool mr-3" *ngIf="isFilterTable && filterSource && filterSource.length">
            <mat-label>Status</mat-label>
            <mat-select [multiple]="false" (selectionChange)="updateSubFilterTable($event)"
              placeholder="" name="filtersubkey" [(ngModel)]="filterSubKey">
              <mat-option *ngFor="let item of filterSubSource" [value]="item.value"> {{item.name}} </mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field class="search-tool" floatLabel="never">
            <input matInput name="valuesearch" [(ngModel)]="value" (keyup)="applyFilter($event)" placeholder="Filter"
                   autocomplete="off">
            <button mat-button *ngIf="!value || value === ''" aria-label="Search" matSuffix mat-icon-button>
              <mat-icon>search</mat-icon>
            </button>
            <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="value=''; applyFilter('');">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <button mat-icon-button color="primary" matTooltip="Create Column Link" menuOpen="false"
            [matMenuTriggerFor]="linkMenu" #linkMenuTrigger="matMenuTrigger"> 
            <!-- <mat-icon>link</mat-icon> -->
            <img class="mx-auto" src="../../../assets/images/link.svg" alt="col-link">
          </button>
          <mat-menu #linkMenu="matMenu" class="col-filters">
            <mat-card class="filter-card" (click)="$event.stopPropagation();">
              <mat-card-header>
                <mat-card-title>Columns</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <form>
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Choose column</mat-label>
                    <mat-select placeholder="Choose column" name="chooseLink" required [(ngModel)]="linkColumn">
                      <mat-option value="">Choose column</mat-option>
                      <mat-option *ngFor="let val of hyperLinkList" [value]="val">{{val}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </form>
                <div class="d-flex">
                  <button mat-raised-button class="" color="primary" (click)="createColumnLink(linkColumn)">Link</button>
                  <div fxFlex></div>
                  <button mat-raised-button class="" color="default" (click)="clearFilter()">Clear</button>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-menu>
          <button mat-icon-button color="primary" menuOpen="false" matTooltip="Filter List"
                  *ngIf="tableOptions.showColFilter" 
                  [matMenuTriggerFor]="filterMenu" #filterMenuTrigger="matMenuTrigger"> <!--  && customCols && customCols.length -->
            <!-- <mat-icon>filter_list</mat-icon> -->
            <img class="mx-auto" src="../../../assets/images/filter.svg" alt="col-link">
          </button>
          <mat-menu #filterMenu="matMenu" class="col-filters">
            <mat-card class="filter-card" (click)="$event.stopPropagation();">
              <mat-card-header>
                <mat-card-title>Filter</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <form [formGroup]="filterForm">
                  <mat-form-field *ngIf="tableOptions.showColFilter" class="w-100" appearance="outline">
                    <mat-label>Choose filter column</mat-label>
                    <mat-select placeholder="Choose filter column" name="chooseFilter" (selectionChange)="eventChange($event)" required>
                      <mat-option value="">Choose filter column</mat-option>
                      <mat-option *ngFor="let val of columnsList" [value]="val">{{ val }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                
                  <mat-form-field *ngIf="selectedColumn !== ''" class="w-100" appearance="outline">
                    <mat-label>Search {{ selectedColumn }}</mat-label>
                    <input matInput type="text" trim="blur" [placeholder]="'Search ' + selectedColumn" required [formControl]="formControls[selectedColumn]">
                  </mat-form-field>
                </form>
                <div class="d-flex">
                  <button mat-raised-button class="" color="primary" (click)="applyMultipleFilters()">Get Data</button>
                  <div fxFlex></div>
                  <button mat-raised-button class="" color="default" (click)="clearFilter()">Clear</button>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-menu>

          <button mat-icon-button menuOpen="false" #listMenuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="belowMenu" color="primary" matTooltip="View Column, Reorder Columns">
            <!-- <mat-icon>view_column</mat-icon> -->
            <img class="mx-auto" src="../../../assets/images/column-reorder.svg" alt="col_reorder">
          </button>
          <mat-menu #belowMenu="matMenu" [hasBackdrop]="true" yPosition="below">
            <div cdkDropList (cdkDropListDropped)="drop($event)">
              <div style="padding: 5px;overflow: hidden;font-family: Arial, Helvetica, sans-serif"
                *ngFor="let col of columns; let i = index" cdkDrag>
                <i class="material-icons color_icon"> drag_handle </i>
                <mat-checkbox color="primary" [checked]="col.isvisible" (click)="$event.stopPropagation()" 
                (change)="showhide(i, col.header)" class="left-align"> {{col.header | titlecase}} </mat-checkbox>
              </div>
            </div>
          </mat-menu>
        <button mat-icon-button matTooltip="Save Settings" color="primary" (click)="saveSettings()">
          <!-- <mat-icon>save</mat-icon> -->
          <img class="mx-auto" src="../../../assets/images/save.svg" id="rfrbtn{{tableOptions.title}}" alt="save">
        </button>
          <div fxFlex fxLayout fxLayoutAlign="end" *ngIf="tableOptions.refreshData">
            <button class="gray" matSuffix mat-icon-button matTooltip="Reload Table Data" (click)="refreshTableData();"
                    color="primary" >
              <!-- <mat-icon id="rfrbtn{{tableOptions.title}}">refresh</mat-icon> -->
              <img class="mx-auto" src="../../../assets/images/refresh.svg" id="rfrbtn{{tableOptions.title}}" [alt]="tableOptions.title">
            </button>
          </div>
          
          <button id="gbtn{{title}}" color="primary"  matSuffix mat-icon-button *ngIf="isFilterTable"
                matTooltip="Download as XLSx" [matMenuTriggerFor]="xlsMenu" aria-label="download xlsx menu">
            <mat-icon class="mat-24">file_download</mat-icon>
          </button>
          <mat-menu #xlsMenu="matMenu">
            <button mat-menu-item id="currentSelection" (click)="downloadAsXls('filtered')">
              <mat-icon class="mat-24">filter_list</mat-icon>
              <span>Filtered Data</span>
            </button>
            <button mat-menu-item id="fullData" (click)="downloadAsXls('full')">
              <mat-icon class="mat-24">file_download</mat-icon>
              <span>Full Data</span>
            </button>
          </mat-menu>
        </form>
      </div>
    </div>
  </mat-toolbar>
  <mat-chip-list aria-label="Column Filters" class="mb10">
    <mat-chip *ngFor="let filter of colFilters" (removed)="removeFilter(filter)">
      {{filter.name}} = *{{filter.value}}* <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-list>
  <mat-card-content>
    <div #MTABLEDIV class="overflow-auto" [ngStyle]="{ height: tableOptions.height, maxHeight: tableOptions.maxHeight}">
      <table mat-table [dataSource]="dataSource" class="" cdkDropList cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)" matSort class="w-100 crud-table" >
        <div *ngFor="let column of columns; let i = index;">
          <ng-container *ngIf="column.isvisible" [matColumnDef]="column.columnDef">
            <th mat-header-cell *matHeaderCellDef mat-sort-header cdkDrag [ngClass]="{'text-center': isTextCenterCol(column.header) }">
              <span *ngIf="showHeaderUpperCase">{{ column.header| camelToHuman:true | uppercase }}</span>
              <span *ngIf="!showHeaderUpperCase">{{ column.header|camelToHuman:true }}</span>
            </th>
            <td mat-cell *matCellDef="let row" [ngClass]="{'text-center': isTextCenterCol(column.header) }">
              <ng-container *ngIf="customCols && isExistCustomCols(column.header)">
                <ng-container *ngFor="let c of customCols">
                  <span *ngIf="c.col === column.header" >
                    <ng-container *ngIf="c.hyperLinkCall">
                      <a href="javascript:" (click)="hyperLinkCall(row, c.col)">
                        <ng-container *ngIf="c.hyperLinkCall.filter && c.hyperLinkCall.filter !== ''">
                          <span>{{ getProperty(row, c.col) | formatCell:c.hyperLinkCall.filter }} </span>
                        </ng-container>
                        <ng-container *ngIf="c.hyperLinkCall.isHtml">
                          <div [innerHTML]="getProperty(row, c.col) | safeHTML"></div>
                        </ng-container>
                        <ng-container *ngIf="c.hyperLinkCall.noFilter">
                          <span>{{getProperty(row, c.col)}}</span>
                        </ng-container>
                      </a>
                    </ng-container>
                    <ng-container *ngIf="c.htmlCols">
                      <div *ngIf="isBool(column.cell(row)) && column.cell(row)"
                        [innerHTML]="c.htmlCols['_success'] | safeHTML"></div>
                      <div *ngIf="isBool(column.cell(row)) && !column.cell(row)"
                          [innerHTML]="c.htmlCols['_failure'] | safeHTML"></div>
                      <div *ngIf="!isBool(column.cell(row)) && c.htmlCols[column.cell(row)]"
                          [innerHTML]="c.htmlCols[column.cell(row)] | safeHTML"></div>
                    </ng-container>
                    <ng-container *ngIf="c.filter && c.filter !== ''">
                      <span  *ngIf="c.filter.indexOf('ellipsis') === -1">{{ column.cell(row) | formatCell:c.filter }} </span>
                      <span *ngIf="c.filter.indexOf('ellipsis') > -1"
                            [matTooltip]="column.cell(row)">{{ column.cell(row) | formatCell:c.filter }} </span>
                    </ng-container>
                    <ng-container *ngIf="c.isHtml">
                      <div [innerHTML]="column.cell(row) | safeHTML"></div>
                    </ng-container>
                  </span>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="column.isHyperLink && !customCols && !isExistCustomCols(column.header)">
                <span matTooltipClass="example-tooltip-red">
                  <a class="pointer" [id]="getProperty(row, column.columnDef)" (click)="hyperLinkCall(row, title)">
                    <span>{{ getProperty(row, column.header)}}</span>
                  </a>
                </span>
              </ng-container>
              <ng-container *ngIf="!customCols && !column.isHyperLink && !isExistCustomCols(column.header)">
                <span class="ellipsis-cell" [matTooltip]="row[column.header]">{{ row[column.header] }}</span>
              </ng-container>
              <!-- <ng-container *ngIf="!customCols && !column.isHyperLink && !isExistCustomCols(column.header)">{{ column.cell(row) }}</ng-container> -->
            </td>
          </ng-container>
        </div>
        <ng-container matColumnDef="action" *ngIf="tableOptions.showAction" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="word-wrap: break-word;"
            [ngClass]="tableOptions.showAction === true? 'color1' : 'color2' ">
            <!--<button id="gbtn{{tableOptions.title}}" mat-icon-button [matMenuTriggerFor]="gactionMenu" [disabled]="selection.selected.length === 0"
              aria-label="global action with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>-->Action
            <!-- <mat-menu #gactionMenu="matMenu">
              <ng-container *ngFor="let item of tableOptions.actionMenuItems">
                <a id="ganch{{item.text}}" *ngIf=item.isGlobal mat-menu-item (click)="globalActionCall(selection.selected, item)">
                  <mat-icon *ngIf=item.icon>{{item.icon}}</mat-icon>
                  <mat-icon *ngIf=!item.icon>arrow_forward_ios</mat-icon>
                  <span>{{ item.text }}</span>
                </a>
              </ng-container>
            </mat-menu> -->
          </th>
          <td mat-cell *matCellDef="let element" style="word-wrap: break-word;"
            [ngClass]="tableOptions.showAction == true? 'color1' : 'color2' ">
            <button id="btn{{tableOptions.title}}" mat-icon-button  color="primary" [matMenuTriggerFor]="actionMenu" aria-label="row action with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu">
              <ng-container *ngFor="let item of tableOptions.actionMenuItems">
                <a id="anch{{item.text}}" *ngIf="item.callback && !item.hideLocal" mat-menu-item (click)="actionCall(element, item)">
                  <mat-icon *ngIf=item.icon>{{item.icon}}</mat-icon>
                  <mat-icon *ngIf=!item.icon>arrow_forward_ios</mat-icon>
                  <span>{{ item.text }}</span>
                </a>
              </ng-container>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator class="t-paginator" [length]="pageSize" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 50, 100, 200 ]"></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
